import { NgModule } from '@angular/core';
import { BrandHashtagsComponent } from './brand-hashtags.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';

const routes = [
  {
      path     : 'brand-hashtags',
      component: BrandHashtagsComponent,
      canActivate: [AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule
  ],
  declarations: [
    BrandHashtagsComponent
  ],
  providers: [
    AuthGuard,
    RoleGuard
  ]
})

export class BrandHashtagsModule { }
